import { render, staticRenderFns } from "./substation.vue?vue&type=template&id=53b3ed6d&scoped=true&"
import script from "./substation.vue?vue&type=script&lang=js&"
export * from "./substation.vue?vue&type=script&lang=js&"
import style0 from "./substation.vue?vue&type=style&index=0&id=53b3ed6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3ed6d",
  null
  
)

export default component.exports